import { MatchedSchedule } from "@common/schemas/domains/accounting/scheduleMatchedDisplay.schema";
import { MatchedCounterpart, MatchedScheduleCard } from "./MatchedScheduleCard";
import styles from "./SchedulePicker.module.scss";

interface Props {
    schedules: MatchedSchedule[];
    counterpart: MatchedCounterpart;
}

/**
 * The matched card inside a Schedule column cell: laid out like the picker's
 * applied row, with the row menu's slot left empty so both pills line up and
 * shrink at the same cell width.
 */
export function MatchedScheduleCell({ schedules, counterpart }: Props) {
    return (
        <div className={styles.appliedRow}>
            <MatchedScheduleCard
                schedules={schedules}
                counterpart={counterpart}
            />
            <span aria-hidden className={styles.menuSpace} />
        </div>
    );
}
